import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { StoreProducts } from 'features/store-common-info/store-products';
import { getTitle } from 'features/page-model/ducks/get-model';
import { AdditionalLinksContainer } from './styles';
import { StorePlan } from '../store-plan';

export const AdditionalLinks: FC = () => {
  const title = useSelector(getTitle);

  return (
    <AdditionalLinksContainer data-qa="additional-links">
      <StoreProducts name={title} />
      <StorePlan />
    </AdditionalLinksContainer>
  );
};
